// extracted by mini-css-extract-plugin
export default {"generateLinkContainer":"MLinkIntegration_generateLinkContainer__pYu-T"};